import i18n from "i18next";
import { ReactNode, useEffect } from "react";
import { I18nextProvider, initReactI18next } from "react-i18next";

import { LOCALE } from "@/constants/locale";
import { SETTINGS_KEYS } from "@/constants/settings-keys";
import ar from "@/locales/ar.json";
import de from "@/locales/de.json";
import en from "@/locales/en.json";
import es from "@/locales/es.json";
import fr from "@/locales/fr.json";
import it from "@/locales/it.json";
import tr from "@/locales/tr.json";

import { getLocalSetting, useSettings } from "./settings-provider";

i18n.use(initReactI18next).init({
    lng: getLocalSetting<string>(SETTINGS_KEYS.LANGUAGE),
    fallbackLng: LOCALE.ENGLISH,

    resources: {
        [LOCALE.SPANISH]: { translation: es },
        [LOCALE.ENGLISH]: { translation: en },
        [LOCALE.GERMAN]: { translation: de },
        [LOCALE.TURKISH]: { translation: tr },
        [LOCALE.ARABIC]: { translation: ar },
        [LOCALE.ITALIAN]: { translation: it },
        [LOCALE.FRENCH]: { translation: fr },
    },
});

export function LanguageProvider({ children }: { children: ReactNode }) {
    const { currentSettings } = useSettings();

    useEffect(() => {
        if (currentSettings.LANGUAGE) {
            i18n.changeLanguage(currentSettings.LANGUAGE);
        }
    }, [currentSettings.LANGUAGE]);

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
